module.exports = new __parcel__URL__("crystal-lake-background-sat.8d73a947.jpg").toString();